module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/android-30dab04a16b485e7ec5f0145f97538dd.svg";